import React, { createContext, useCallback, useState } from 'react';

export const GeoLocationContext = createContext(null);

export const GeoLocationProvider = ({ children }) => {
  let [location, setLocation] = useState('');

  const updateLocation = useCallback((locationValue) => {
    setLocation(locationValue);
  }, []);

  return <GeoLocationContext.Provider value={{ location, updateLocation }}>{children}</GeoLocationContext.Provider>;
};
